'use client';

import React__default, { useState, useMemo, useEffect } from 'react';
import MultipleSelect from '../../MultipleSelect/index.js';

var JobAlertSelect = function (props) {
    var _a = props.isMobile, isMobile = _a === void 0 ? false : _a, _b = props.isOpened, isOpened = _b === void 0 ? false : _b, _c = props.customClass, customClass = _c === void 0 ? '' : _c, title = props.title, jobSelectValue = props.jobSelectValue, pleaseSelect = props.pleaseSelect, limitAlertText = props.limitAlertText, _d = props.limitSelectCount, limitSelectCount = _d === void 0 ? 3 : _d, _e = props.jobOptions, jobOptions = _e === void 0 ? [] : _e, _f = props.customWidth, customWidth = _f === void 0 ? '350px' : _f, setJobSelect = props.setJobSelect, langCode = props.langCode, hasError = props.hasError, sortEnable = props.sortEnable;
    var _g = useState(false), isValueChange = _g[0], setIsValueChange = _g[1];
    var jobValue = useState(jobSelectValue || [])[0];
    // parse props.jobOptions to TSelectOption[]
    var memoOptions = useMemo(function () {
        var optionList = [];
        if (jobOptions !== undefined && (jobOptions === null || jobOptions === void 0 ? void 0 : jobOptions.length) > 0) {
            jobOptions.map(function (item, _) {
                var _a, _b, _c;
                var itemId = (_b = (_a = item === null || item === void 0 ? void 0 : item.id) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : '-1';
                optionList.push({
                    id: parseInt(itemId),
                    name: (_c = item.text) !== null && _c !== void 0 ? _c : ''
                });
            });
        }
        return optionList;
    }, [jobOptions]);
    var handleOnChangeValue = function (value) {
        setJobSelect && setJobSelect(value);
    };
    useEffect(function () {
        // Auto set value change after modal opened 1s
        if (isOpened) {
            setTimeout(function () {
                setIsValueChange(true);
            }, 1000);
        }
    });
    useEffect(function () {
        if (isOpened && !isValueChange && jobValue !== jobSelectValue) {
            setIsValueChange(true);
        }
    }, [jobSelectValue]);
    return (React__default.createElement("div", { className: customClass },
        React__default.createElement("label", { className: "".concat(isValueChange ? 'changed' : '') }, title),
        React__default.createElement("div", null,
            React__default.createElement(MultipleSelect, { name: 'job-alert-select', options: memoOptions, defaultSelect: jobSelectValue, onChange: function (e) { return handleOnChangeValue(e.value); }, selectPlaceholder: pleaseSelect, optionsStyle: { maxHeight: '200px' }, dropdownStyle: { width: customWidth, boxShadow: 'none' }, limitText: limitAlertText, limit: limitSelectCount, isMobile: isMobile, langCode: langCode, sortEnable: sortEnable, hasError: hasError }))));
};

export { JobAlertSelect as default };
//# sourceMappingURL=index.js.map
